import type { SVGProps } from "react";
export interface Parcel02LockIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Parcel02LockIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Parcel02LockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 10.086V8.413l-6.75 3.749v7.556a1.122 1.122 0 0 1 .246 2.175l-.337.102a4.12 4.12 0 0 1-2.779-.255l-.234-.118-6-3.28a4.13 4.13 0 0 1-2.146-3.62V8.28c0-.704.182-1.381.508-1.978a1.1 1.1 0 0 1 .17-.285A4.1 4.1 0 0 1 3.021 4.66l2.97-1.624.049-.026 2.981-1.63.234-.118a4.13 4.13 0 0 1 3.724.119l6 3.28.242.143c.5.319.915.738 1.23 1.222a1.1 1.1 0 0 1 .166.276c.326.597.508 1.274.508 1.978v1.806a1.125 1.125 0 0 1-2.25 0M4.329 6.51 11 10.214l2.185-1.215-6.653-3.694L4.33 6.509Zm7.57-3.154a1.88 1.88 0 0 0-1.583-.1l-.215.1-1.235.674 6.636 3.684 2.167-1.204zM3.125 14.722c0 .686.374 1.317.976 1.645l5.774 3.156v-7.361l-6.75-3.749z"
      />
      <path
        fill={color}
        d="M17.125 20.875h3.75v-1.75h-3.75zM4.017 12.952a1.125 1.125 0 0 1 1.425-.488l.104.051 3 1.666.099.061A1.126 1.126 0 0 1 7.558 16.2l-.104-.05-3-1.668-.099-.06a1.126 1.126 0 0 1-.338-1.47m15.608 2.798a.625.625 0 0 0-1.25 0v1.125h1.25zm2.25 1.314A2.13 2.13 0 0 1 23.125 19v2A2.125 2.125 0 0 1 21 23.125h-4A2.126 2.126 0 0 1 14.874 21v-2c0-.862.514-1.603 1.251-1.936V15.75a2.874 2.874 0 0 1 5.75 0z"
      />
    </svg>
  );
}
